import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { MapView } from "../components/MapView";
import { SearchBox } from "../components/SearchBox";
import type { SystemRecordView, SystemSummary } from "@shared/types";

export function Explore() {
  const [systems, setSystems] = useState<SystemSummary[]>([]);
  const [ross, setRoss] = useState<SystemRecordView | null>(null);

  useEffect(() => {
    api<{ systems: SystemSummary[] }>("/api/systems").then((r) => setSystems(r.systems)).catch(() => setSystems([]));
    api<SystemRecordView>("/api/systems/ross-river").then(setRoss).catch(() => setRoss(null));
  }, []);

  return (
    <>
      <section className="page-hero">
        <div className="wrap">
          <p className="kicker">Explore</p>
          <h1>Navigate by catchment, not by address.</h1>
          <p className="lede">The primary interface is a system map. Property search belongs on floodplain.com.au.</p>
          <SearchBox />
        </div>
      </section>
      {ross && <MapView lat={ross.header.lat} lng={ross.header.lng} layers={ross.layers} isDemo={ross.isDemo} zoom={9.4} />}
      <section className="section" style={{ paddingTop: 36 }}>
        <div className="wrap results">
          {systems.map((s) => (
            <Link className="result" key={s.slug} to={`/system/${s.slug}`}>
              <span className="kicker">{s.kind} · {s.lga}</span>
              <h3>{s.name}</h3>
              <p className="muted small">
                {s.studyCount} studies · {s.modelCount} models · {s.eventCount} events
              </p>
            </Link>
          ))}
        </div>
      </section>
    </>
  );
}
